module.exports = __webpack_public_path__ + "static/media/datascience1.ec479dfa.jpg";